var v = "5.8.1";
var fr = 29.9700012207031;
var ip = 20.0000008146167;
var op = 120.0000048877;
var w = 468;
var h = 468;
var nm = "ReNewDots 2";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "dot",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.667
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.333
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 25,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 31.0000012626559,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 25,
                        s: [
                            234.422,
                            143.957,
                            0
                        ],
                        to: [
                            0,
                            -3.333,
                            0
                        ],
                        ti: [
                            0,
                            3.333,
                            0
                        ]
                    },
                    {
                        t: 31.0000012626559,
                        s: [
                            234.422,
                            123.957,
                            0
                        ]
                    }
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        5.01
                                    ],
                                    [
                                        -5,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -5
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        5.01,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        -5
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        5.01,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        5.01
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -5,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -9.065,
                                        -5e-3
                                    ],
                                    [
                                        -5e-3,
                                        -9.065
                                    ],
                                    [
                                        -5e-3,
                                        -9.065
                                    ],
                                    [
                                        9.065,
                                        -5e-3
                                    ],
                                    [
                                        9.065,
                                        -5e-3
                                    ],
                                    [
                                        -5e-3,
                                        9.065
                                    ],
                                    [
                                        -5e-3,
                                        9.065
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 25.0000010182709,
        op: 325.000013237521,
        st: 25.0000010182709,
        bm: 0
    },
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "dot",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.667
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.333
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 31,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 37.0000015070409,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    267.654,
                    129.226,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0.94,
                                        0.31
                                    ],
                                    [
                                        -1.56,
                                        4.75
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -4.76,
                                        -1.56
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1.55,
                                        -4.76
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        3.82,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        -4.76,
                                        -1.55
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1.56,
                                        -4.76
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        4.76,
                                        1.55
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -1.25,
                                        3.83
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -0.93,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -2.818,
                                        8.617
                                    ],
                                    [
                                        -8.618,
                                        -2.813
                                    ],
                                    [
                                        -8.618,
                                        -2.813
                                    ],
                                    [
                                        2.822,
                                        -8.614
                                    ],
                                    [
                                        2.822,
                                        -8.614
                                    ],
                                    [
                                        8.622,
                                        2.816
                                    ],
                                    [
                                        8.622,
                                        2.816
                                    ],
                                    [
                                        0.002,
                                        9.066
                                    ],
                                    [
                                        0.002,
                                        9.066
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 31.0000012626559,
        op: 331.000013481906,
        st: 31.0000012626559,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "dot",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.667
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.333
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 37,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 43.0000017514259,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    297.58,
                    144.614,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        1.61,
                                        1.19
                                    ],
                                    [
                                        -2.96,
                                        4.03
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -4.04,
                                        -2.96
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        2.97,
                                        -4.04
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        2.78,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        -4.04,
                                        -2.96
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        2.97,
                                        -4.04
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        4.04,
                                        2.97
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -1.78,
                                        2.42
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -1.87,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -5.364,
                                        7.308
                                    ],
                                    [
                                        -7.314,
                                        -5.362
                                    ],
                                    [
                                        -7.314,
                                        -5.362
                                    ],
                                    [
                                        5.366,
                                        -7.312
                                    ],
                                    [
                                        5.366,
                                        -7.312
                                    ],
                                    [
                                        7.306,
                                        5.368
                                    ],
                                    [
                                        7.306,
                                        5.368
                                    ],
                                    [
                                        -4e-3,
                                        9.068
                                    ],
                                    [
                                        -4e-3,
                                        9.068
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 37.0000015070409,
        op: 337.000013726291,
        st: 37.0000015070409,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "dot",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.667
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.333
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 43,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 49.0000019958109,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    321.25,
                    168.531,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        1.77,
                                        2.46
                                    ],
                                    [
                                        -4.07,
                                        2.93
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -2.92,
                                        -4.07
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        4.07,
                                        -2.92
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1.83,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        -2.92,
                                        -4.07
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        4.07,
                                        -2.92
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        2.92,
                                        4.07
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -1.6,
                                        1.15
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -2.82,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -7.363,
                                        5.291
                                    ],
                                    [
                                        -5.293,
                                        -7.369
                                    ],
                                    [
                                        -5.293,
                                        -7.369
                                    ],
                                    [
                                        7.367,
                                        -5.289
                                    ],
                                    [
                                        7.367,
                                        -5.289
                                    ],
                                    [
                                        5.287,
                                        7.361
                                    ],
                                    [
                                        5.287,
                                        7.361
                                    ],
                                    [
                                        0.007,
                                        9.071
                                    ],
                                    [
                                        0.007,
                                        9.071
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 43.0000017514259,
        op: 343.000013970676,
        st: 43.0000017514259,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 3,
        nm: "Trace Layer 4: Path 1 [1.1]",
        cl: "1",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10,
                x: "var $bm_rt;\nvar pathToTrace = thisComp.layer('Layer 4')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\nvar pathLayer = thisComp.layer('Layer 4');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ef: [
            {
                ty: 5,
                nm: "Trace Path",
                np: 4,
                mn: "Pseudo/ADBE Trace Path",
                ix: 1,
                en: 1,
                ef: [
                    {
                        ty: 0,
                        nm: "Progress",
                        mn: "Pseudo/ADBE Trace Path-0001",
                        ix: 1,
                        v: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.833
                                        ],
                                        y: [
                                            0.833
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.167
                                        ],
                                        y: [
                                            0.167
                                        ]
                                    },
                                    t: 0,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    t: 29.9700012207031,
                                    s: [
                                        100
                                    ]
                                }
                            ],
                            ix: 1,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Layer 4').content('Trim Paths 1').end;"
                        }
                    },
                    {
                        ty: 7,
                        nm: "Loop",
                        mn: "Pseudo/ADBE Trace Path-0002",
                        ix: 2,
                        v: {
                            a: 0,
                            k: 1,
                            ix: 2
                        }
                    }
                ]
            }
        ],
        ip: 0,
        op: 300.00001221925,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Layer 4",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234.421,
                    230.789,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.063
                                    ],
                                    [
                                        59.002,
                                        0
                                    ],
                                    [
                                        0,
                                        59.002
                                    ],
                                    [
                                        -59.002,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        3.121,
                                        10.036
                                    ],
                                    [
                                        0,
                                        59.002
                                    ],
                                    [
                                        -59.002,
                                        0
                                    ],
                                    [
                                        0,
                                        -59.002
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        102.03,
                                        -31.769
                                    ],
                                    [
                                        106.833,
                                        0
                                    ],
                                    [
                                        0,
                                        106.833
                                    ],
                                    [
                                        -106.833,
                                        0
                                    ],
                                    [
                                        0,
                                        -106.833
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 18.135,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.018
                                ],
                                y: [
                                    0.997
                                ]
                            },
                            o: {
                                x: [
                                    0.041
                                ],
                                y: [
                                    0.513
                                ]
                            },
                            t: 51,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 66.0000026882351,
                            s: [
                                93
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 51.0000020772726,
        op: 351.000014296523,
        st: 51.0000020772726,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "arrow head",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10,
                x: "var $bm_rt;\n$bm_rt = $bm_sum(thisComp.layer('Trace Layer 4: Path 1 [1.1]').transform.rotation, 85);"
            },
            p: {
                a: 0,
                k: [
                    335.685,
                    197.549,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\n$bm_rt = thisComp.layer('Trace Layer 4: Path 1 [1.1]').transform.position;"
            },
            a: {
                a: 0,
                k: [
                    0.964,
                    -14.885,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -32.903,
                                        16.452
                                    ],
                                    [
                                        0,
                                        -16.452
                                    ],
                                    [
                                        32.903,
                                        16.452
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 18.135,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 51,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 58.0000023623884,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 51,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 58.0000023623884,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 51.0000020772726,
        op: 351.000014296523,
        st: 51.0000020772726,
        bm: 0
    },
    {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "Layer 8",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    235.132,
                    231.362,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    235.132,
                    231.362,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        7.169
                                    ],
                                    [
                                        0,
                                        -7.169
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 18.268,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                235.132,
                                285.071
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 2",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 2,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -7.06
                                    ],
                                    [
                                        0,
                                        7.06
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 18.268,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                235.132,
                                177.544
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 3",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 3,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 17,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 23.0000009368092,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 17,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 23.0000009368092,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 4,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 17.0000006924242,
        op: 317.000012911675,
        st: 17.0000006924242,
        bm: 0
    },
    {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: "Layer 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    235.132,
                    231.362,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    235.132,
                    231.362,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -12.066
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -13.23,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -12.066
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        13.23,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -13.23,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        12.066
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        13.23,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        12.066
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        24.579,
                                        -45.061
                                    ],
                                    [
                                        -10.013,
                                        -45.061
                                    ],
                                    [
                                        -33.968,
                                        -23.213
                                    ],
                                    [
                                        -33.968,
                                        -23.213
                                    ],
                                    [
                                        -10.013,
                                        -1.365
                                    ],
                                    [
                                        10.013,
                                        -1.365
                                    ],
                                    [
                                        33.968,
                                        20.482
                                    ],
                                    [
                                        33.968,
                                        23.213
                                    ],
                                    [
                                        10.013,
                                        45.061
                                    ],
                                    [
                                        -26.399,
                                        45.061
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.235294118524,
                                0.564705908298,
                                0.807843148708,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 18.268,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                235.132,
                                231.474
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 11,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 17.0000006924242,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 11,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 17.0000006924242,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 4,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 11.0000004480392,
        op: 311.00001266729,
        st: 11.0000004480392,
        bm: 0
    },
    {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: "Layer 1",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.667
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.333
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 10.0000004073083,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        121.069
                                    ],
                                    [
                                        -121.069,
                                        0
                                    ],
                                    [
                                        0,
                                        -121.069
                                    ],
                                    [
                                        121.069,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        -121.069,
                                        0
                                    ],
                                    [
                                        0,
                                        -121.069
                                    ],
                                    [
                                        121.069,
                                        0
                                    ],
                                    [
                                        0,
                                        121.069
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0.421,
                                        216.004
                                    ],
                                    [
                                        -218.793,
                                        -3.211
                                    ],
                                    [
                                        0.421,
                                        -222.425
                                    ],
                                    [
                                        219.636,
                                        -3.211
                                    ],
                                    [
                                        0.421,
                                        216.004
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.941176474094,
                                0.960784316063,
                                0.984313726425,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 300.00001221925,
        st: 0,
        bm: 0
    }
];
var markers = [];
var USDCRenew = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, USDCRenew as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=USDCRenew.json.es.js.map
